import useSWRImmutable from 'swr/immutable'

import { type SpecializationOptionsType } from '../types/TherapistStateType'
import { fetchUseSpecializations } from '../utilities/apiUtils'
import { convertArrayToObjectNoDuplicateKey } from '../utilities/arrayTobject'

const useSpecializations = () => {
  const { data } = useSWRImmutable('useSpecializations', fetchUseSpecializations)

  return {
    specializations: convertArrayToObjectNoDuplicateKey(data || [], 'id', 'name') as SpecializationOptionsType,
    rawSpecializations: data || [],
  }
}

export default useSpecializations
